import Lottie from 'lottie-react';
import b4aLoadingAnimation from './b4aLoadingAnimation.json';

const B4aLoader = () => {
  return (
    <div className="flex flex-col items-center justify-center">
      <Lottie animationData={b4aLoadingAnimation} loop={true} height={100} />
      <div className="text-sm -mt-4 text-[#f9f9f9]">Loading...</div>
    </div>
  )
}

export default B4aLoader